// extracted by mini-css-extract-plugin
export var cardLayout = "_6i-1";
export var paginationContainer = "_6i-0";